import { ApplicationRef, createComponent, EnvironmentInjector, inject, Injectable, Type, Injector } from '@angular/core';
import { DialogModalComponent } from './dialog-modal.component';
import { MODAL_DATA } from './modal-data.token';

export interface IDialogParameters {
    arguments: { width: string, height: string, title: string },
    closeOnBackdropClick: boolean,
    closeOnEscapeKey: boolean,
    showCloseButton: boolean,
    data?: any
}

@Injectable({ providedIn: 'root' })
export class DialogService {
    private appRef = inject(ApplicationRef)
    private injector = inject(EnvironmentInjector)
    private modalComponentRef: any = null
    private isClosing = false

    async open(componentType: Type<any>, data: any = null, parameters?: IDialogParameters) {
        if (this.modalComponentRef || this.isClosing) {
            await this.close()
        }

        const inputInjector = Injector.create({
            parent: this.injector,
            providers: [
                { provide: MODAL_DATA, useValue: data }
            ]
        })

        this.modalComponentRef = createComponent(DialogModalComponent, {
            environmentInjector: this.injector,
            elementInjector: inputInjector
        })

        this.appRef.attachView(this.modalComponentRef.hostView)
        document.body.appendChild(this.modalComponentRef.location.nativeElement)

        setTimeout(() => {
            if (this.modalComponentRef) {
                this.modalComponentRef.instance.loadContent(componentType)
                this.modalComponentRef.instance.classApplied.set(true)
                this.modalComponentRef.instance.parameters.set(parameters)
            }
        }, 0)
    }

    close(): Promise<void> {
        if (!this.modalComponentRef) {
            return Promise.resolve()
        }

        this.modalComponentRef.instance.classApplied.set(false)

        return new Promise(resolve => {
            setTimeout(() => {
                if (this.modalComponentRef) {
                    const elementToRemove = this.modalComponentRef.location.nativeElement
                    this.appRef.detachView(this.modalComponentRef.hostView)
                    this.modalComponentRef.destroy()

                    if (elementToRemove.parentNode) {
                        elementToRemove.parentNode.removeChild(elementToRemove)
                    }

                    this.modalComponentRef = null
                }
                resolve()
            }, 300)
        })
    }
}
